'use client';
import Tooltip from "./Tooltip.js";
export default Tooltip;